// extracted by mini-css-extract-plugin
export default {"link":"nav-tab-link_link__btKZt","linkName":"nav-tab-link_linkName__QIOeZ"};